module.exports = __webpack_public_path__ + "static/media/AAVE-logo.ba76964b.png";